import { useParams, useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { COURSE_SERIES_CONFIG } from './index';
import CourseSeries from './CourseSeries';
import './SeriesPage.css';

const SeriesPage = () => {
  const { seriesName } = useParams();
  const navigate = useNavigate();
  const series = COURSE_SERIES_CONFIG.find((s) => s.slug === seriesName);

  if (!series) {
    return (
      <Container className="mt-5">
        <div className="text-center">
          <h2>Series Not Found</h2>
          <p>The requested series could not be found.</p>
          <Button variant="primary" onClick={() => navigate('/')}>
            Back to Library
          </Button>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="series-page">
      {/* Breadcrumb Navigation */}
      <Breadcrumb className="series-breadcrumb">
        <Breadcrumb.Item onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          Library
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{series.title}</Breadcrumb.Item>
      </Breadcrumb>

      {/* Back Button */}
      <div className="series-header-actions">
        <Button
          variant="outline-secondary"
          onClick={() => navigate('/')}
          className="back-button"
        >
          ← Back to Library
        </Button>
      </div>

      {/* Series Content */}
      <div className="series-content">
        <CourseSeries
          title={series.title}
          data={series.data}
          headerStyle={series.headerStyle}
          buttonStyle={series.buttonStyle}
          containerStyle={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}
          itemsPerPage={25}
          showPagination={true}
        />
      </div>
    </Container>
  );
};

export default SeriesPage;

